import { IBranchPin, IBranchSettingData } from 'interfaces/redux/branch-setting'
import {
  ICustomTotalParam,
  ICutoffParams,
  type IDetailGoalVersion,
  IGoalCutoffParams,
  type IGoalVersionSimulationParams,
  IParamCreateGoalVersion,
} from 'interfaces/redux/goal'
import {
  IListRequestShareDataParams,
  IManualInputDataAPI,
  IRegistrationParamsAPI,
  IRequestShareData,
  IShareEmissionParams,
} from 'interfaces/redux/registration'
import { axios } from 'utils/plugins'

import { apiRoutes } from '.'

export const getDashboard = async () => {
  try {
    const result = await axios.get(apiRoutes.DASHBOARD)
    return result
  } catch (err) {
    throw err
  }
}

export const login = async (data: ILoginDataAPI) => {
  try {
    const result = await axios.post(apiRoutes.LOGIN, data)
    return result
  } catch (err) {
    throw err
  }
}

export const impersonate = async (userId: string, data: { token: string }) => {
  try {
    const result = await axios.post(
      `${apiRoutes.USER}/${userId}/impersonate`,
      data,
    )
    return result
  } catch (err) {
    throw err
  }
}

export const forgotPassWord = async (data: IForgotPasswordDataReq) => {
  try {
    const result = await axios.post(apiRoutes.FORGOT_PASSWORD, data)
    return result
  } catch (err) {
    throw err
  }
}

export const changePassword = async (data: IDataChangePasswordAPI) => {
  try {
    const result = await axios.post(apiRoutes.CHANGE_PASSWORD, data)
    return result
  } catch (err) {
    throw err
  }
}

export const getAnalysisAll = async (body: any) => {
  try {
    const result = await axios.get(apiRoutes.ANALYSIS, { params: body })
    return result
  } catch (err) {
    throw err
  }
}

export const getBranches = async (params: any) => {
  try {
    const result = await axios.get(apiRoutes.SETTING_BRANCH, { params })
    return result
  } catch (err) {
    throw err
  }
}

export const getBranchesOfCompanyInvited = async (
  params: any,
  companyTargetId: string,
) => {
  try {
    const result = await axios.get(
      `${apiRoutes.COMPANIES}/${companyTargetId}/branches`,
      { params },
    )
    return result
  } catch (err) {
    throw err
  }
}

export const getNameRegistrationData = async (params: any) => {
  try {
    const result = await axios.get(`${apiRoutes.REGISTRATION}/name-select`, {
      params,
    })
    return result
  } catch (err) {
    throw err
  }
}

export const updateBranchSelect = async (id: string, body: any) => {
  try {
    const result = await axios.patch(apiRoutes.UPDATE_SELECT_BRANCH, body)
    return result
  } catch (err) {
    throw err
  }
}

export const getRegistrationUsers = async (params: any) => {
  try {
    const result = await axios.get(apiRoutes.USER, { params })
    return result
  } catch (err) {
    throw err
  }
}

export const resendVerifyUserChild = async (id: string, params: any) => {
  try {
    const result = await axios.patch(`${apiRoutes.USER}/${id}/resend-verify`, {
      params,
    })
    return result
  } catch (err) {
    throw err
  }
}

export const getDetailUserInfo = async (id: string) => {
  try {
    const result = await axios.get(`${apiRoutes.USER}/${id}`)
    return result
  } catch (err) {
    throw err
  }
}

export const editRegistrationUserInfo = async (
  id: string,
  data: IUserSettingData,
) => {
  try {
    const result = await axios.patch(`${apiRoutes.USER}/${id}`, data)
    return result
  } catch (err) {
    throw err
  }
}

export const addRegistrationUserInfo = async (data: IUserSettingData) => {
  try {
    const result = await axios.post(`${apiRoutes.USER}`, data)
    return result
  } catch (err) {
    throw err
  }
}

export const getAnalysisScope1 = async (body: any) => {
  try {
    const result = await axios.get(apiRoutes.ANALYSIS_SCOPE1, { params: body })
    return result
  } catch (err) {
    throw err
  }
}

export const getExportAnalysisScope1 = async (
  params: IAnalysisScope1ParamsAPI,
) => {
  try {
    const result = await axios.get(apiRoutes.ANALYSIS_EXPORT_SCOPE1, {
      params,
    })
    return result
  } catch (err) {
    throw err
  }
}

export const getAnalysisScope2 = async (body: any) => {
  try {
    const result = await axios.get(apiRoutes.ANALYSIS_SCOPE2, { params: body })
    return result
  } catch (err) {
    throw err
  }
}

export const getExportAnalysisScope2 = async (
  params: IAnalysisScope2ParamsAPI,
) => {
  try {
    const result = await axios.get(apiRoutes.ANALYSIS_EXPORT_SCOPE2, {
      params,
    })
    return result
  } catch (err) {
    throw err
  }
}

export const contactUs = async (data: IContactDataAPI) => {
  try {
    const result = await axios.post(apiRoutes.CONTACT_US, data)
    return result
  } catch (err) {
    throw err
  }
}

export const getListEmission = async (params: IEmissionParamsAPI) => {
  try {
    const result = await axios.get(apiRoutes.EMISSON, { params })
    return result
  } catch (err) {
    throw err
  }
}

export const getDetailEmission = async (id: string) => {
  try {
    const result = await axios.get(`${apiRoutes.EMISSON}/${id}`)
    return result
  } catch (err) {
    throw err
  }
}

export const getRegistration = async (params: IRegistrationParamsAPI) => {
  try {
    const result = await axios.get(apiRoutes.REGISTRATION, {
      params,
    })
    return result
  } catch (err) {
    throw err
  }
}

export const exportCSVRegistration = async (params: IRegistrationParamsAPI) => {
  try {
    const result = await axios.get(`${apiRoutes.REGISTRATION}/export-csv`, {
      params,
      responseType: 'blob',
    })
    return result
  } catch (err) {
    throw err
  }
}

export const downloadTemplateExcel = async (params: { filePath: string }) => {
  try {
    const result = await axios.get(`${apiRoutes.REGISTRATION}/csv-download`, {
      params,
      responseType: 'blob',
    })
    return result
  } catch (err) {
    throw err
  }
}

export const downloadTemplateScopeExcel = async (params: { scope: string }) => {
  try {
    const result = await axios.get(`${apiRoutes.REGISTRATION}/excel-download`, {
      params,
      responseType: 'blob',
    })
    return result
  } catch (err) {
    throw err
  }
}

export const downloadEmissionTemplate = async (params: { scope: string }) => {
  try {
    const result = await axios.get(
      `${apiRoutes.REGISTRATION}/emission-download`,
      {
        params,
        responseType: 'blob',
      },
    )
    return result
  } catch (err) {
    throw err
  }
}

export const deleteRegistration = async (data: string[]) => {
  try {
    const result = await axios.delete(`${apiRoutes.REGISTRATION}/${data}`)
    return result
  } catch (err) {
    throw err
  }
}

export const getRegistrationID = async (id: string) => {
  try {
    const result = await axios.get(`${apiRoutes.REGISTRATION}/${id}`)
    return result
  } catch (err) {
    throw err
  }
}

export const putRegistrationID = async (id: string, data: any) => {
  try {
    const result = await axios.put(`${apiRoutes.REGISTRATION}/${id}`, data)
    return result
  } catch (err) {
    throw err
  }
}

export const getCountry = async () => {
  try {
    const result = await axios.get(apiRoutes.COUNTRY)
    return result
  } catch (err) {
    throw err
  }
}

export const getAnalysisOther = async (body: any) => {
  try {
    const result = await axios.get(apiRoutes.ANALYSIS_OTHER, { params: body })
    return result
  } catch (err) {
    throw err
  }
}

export const getScope = async (params?: IParamsGetScope) => {
  try {
    const result = await axios.get(apiRoutes.SCOPE, {
      params,
    })
    return result
  } catch (err) {
    throw err
  }
}

export const getReport = async (params: IGetReportParamsAPI) => {
  try {
    const result = await axios.get(apiRoutes.REPORT, { params })
    return result
  } catch (err) {
    throw err
  }
}

export const getGarbages = async (params: { page?: number }) => {
  try {
    const result = await axios.get(`${apiRoutes.GARGABE}/trash`, {
      params,
    })
    return result
  } catch (err) {
    throw err
  }
}

export const deleteGarbage = async (id: string) => {
  try {
    const result = await axios.delete(`${apiRoutes.GARGABE}/${id}`)
    return result
  } catch (err) {
    throw err
  }
}

export const restoreGarabge = async (id: string) => {
  try {
    const result = await axios.patch(`${apiRoutes.GARGABE}/${id}/restore`)
    return result
  } catch (err) {
    throw err
  }
}

export const emptyGarabges = async () => {
  try {
    const result = await axios.delete(`${apiRoutes.GARGABE}/all`)
    return result
  } catch (err) {
    throw err
  }
}

export const getBranchSettingDetail = async (id: string) => {
  try {
    const result = await axios.get(`${apiRoutes.SETTING_BRANCH}/${id}`)
    return result
  } catch (err) {
    throw err
  }
}

export const addBranchSetting = async (params: IBranchSettingData) => {
  try {
    const result = await axios.post(`${apiRoutes.SETTING_BRANCH}`, {
      ...params,
    })
    return result
  } catch (err) {
    throw err
  }
}

export const copyBranchSetting = async (id: string) => {
  try {
    const result = await axios.put(
      `${apiRoutes.SETTING_BRANCH}/${id}/duplicate`,
    )
    return result
  } catch (err) {
    throw err
  }
}

export const pinBranchSetting = async (id: string, data: IBranchPin) => {
  try {
    const result = await axios.patch(
      `${apiRoutes.SETTING_BRANCH}/${id}/pin`,
      data,
    )
    return result
  } catch (err) {
    throw err
  }
}

export const updateBranchSetting = async (
  id: string,
  data: IBranchSettingData,
) => {
  try {
    const result = await axios.patch(`${apiRoutes.SETTING_BRANCH}/${id}`, data)
    return result
  } catch (err) {
    throw err
  }
}

export const manuaInput = async (data: IManualInputDataAPI) => {
  try {
    const result = await axios.post(apiRoutes.REGISTRATION, data)
    return result
  } catch (err) {
    throw err
  }
}

export const getUserID = async () => {
  try {
    const result = await axios.get(apiRoutes.USER_ID)
    return result
  } catch (err) {
    throw err
  }
}

export const deleteBranchSetting = async (id: string) => {
  try {
    const result = await axios.delete(`${apiRoutes.SETTING_BRANCH}/${id}`)
    return result
  } catch (err) {
    throw err
  }
}

export const resetPassword = async (data: IResetPasswordAPIReq) => {
  try {
    const result = await axios.post(`${apiRoutes.RESET_PASSWORD}`, data)
    return result
  } catch (err) {
    throw err
  }
}

export const manualUpload = async (data: any) => {
  try {
    const result = await axios.post(apiRoutes.MANUAL_UPLOAD, data)
    return result
  } catch (err) {
    throw err
  }
}

export const uploadExcel = async (data: any) => {
  try {
    const result = await axios.post(apiRoutes.UPLOAD_EXCEL, data)
    return result
  } catch (err) {
    throw err
  }
}

export const analyzeInvoice = async (data: FormData) => {
  try {
    const result = await axios.post(apiRoutes.INVOICE_OCR_ANALYZE, data)
    return result
  } catch (err) {
    throw err
  }
}

export const getPaymentHistory = async (data: any) => {
  try {
    const result = await axios.post(apiRoutes.PAYMENT_HISTORY, data)
    return result
  } catch (err) {
    throw err
  }
}

export const createSubscription = async (data: any) => {
  try {
    const result = await axios.post(apiRoutes.PAYMENT_CREATE_SUBSCRIPTION, data)
    return result
  } catch (err) {
    throw err
  }
}

export const cancelSubscription = async (param: any) => {
  try {
    const result = await axios.get(apiRoutes.PAYMENT_CANCEL_SUBSCRIPTION, {
      params: param,
    })
    return result
  } catch (err) {
    throw err
  }
}

export const paymentSuccess = async (data: any) => {
  try {
    const result = await axios.post(apiRoutes.PAYMENT_SUCCESS, data)
    return result
  } catch (err) {
    throw err
  }
}

export const paymentFailure = async (data: any) => {
  try {
    const result = await axios.post(apiRoutes.PAYMENT_FAILURE, data)
    return result
  } catch (err) {
    throw err
  }
}

export const checkSubscription = async () => {
  try {
    const result = await axios.get(apiRoutes.CHECK_SUBSCRIPTION)
    return result
  } catch (err) {
    throw err
  }
}

export const getUserParent = async () => {
  try {
    const result = await axios.get(apiRoutes.GET_PARENT_USER)
    return result
  } catch (err) {
    throw err
  }
}

export const getListNoti = async (params: any) => {
  try {
    const result = await axios.get(`${apiRoutes.NOTIFICATION}`, { params })
    return result
  } catch (err) {
    throw err
  }
}

export const createItem = async (params: { name: string }) => {
  try {
    const result = await axios.post(apiRoutes.ITEM, params)
    return result
  } catch (err) {
    throw err
  }
}

export const getListItemScope2 = async () => {
  try {
    const result = await axios.get(`${apiRoutes.ITEM}`)
    return result
  } catch (err) {
    throw err
  }
}

export const getListItemScope2ByBranch = async (
  id: string,
  params: IParamsGetScope,
) => {
  try {
    const result = await axios.get(`${apiRoutes.ITEM}/${id}`, {
      params,
    })
    return result
  } catch (err) {
    throw err
  }
}

export const getCheckSettingBranch = async (data: any, id: string) => {
  try {
    const result = await axios.post(
      `${apiRoutes.SETTING_BRANCH}/${id}/check-items`,
      data,
    )
    return result
  } catch (err) {
    throw err
  }
}

export const getAnalysisScope3 = async (body: any) => {
  try {
    const result = await axios.get(apiRoutes.ANALYSIS_SCOPE3, { params: body })
    return result
  } catch (err) {
    throw err
  }
}

export const getListImageManagement = async (
  params: IRegistrationParamsAPI,
) => {
  try {
    const result = await axios.get(apiRoutes.IMAGE_MANAGEMENT, {
      params,
    })
    return result
  } catch (err) {
    throw err
  }
}

export const createDataWithImage = async (body: any) => {
  try {
    const result = await axios.post(apiRoutes.REGISTRATION_UPLOAD_IMAGE, body)
    return result
  } catch (err) {
    throw err
  }
}

export const getListDataEmissionScope3 = async (params?: IParamsGetScope) => {
  try {
    const result = await axios.get(apiRoutes.GET_DATA_EMISSION_SCOPE3, {
      params,
    })
    return result
  } catch (err) {
    throw err
  }
}

export const getSettingOption = async (option: string, params: any) => {
  try {
    const result = await axios.get(`${apiRoutes.SYSTEM_SETTING}/${option}`, {
      params,
    })
    return result
  } catch (err) {
    throw err
  }
}

export const createEmissionScope = async (data: any) => {
  try {
    const result = await axios.post(apiRoutes.EMISSON, data)
    return result
  } catch (err) {
    throw err
  }
}

export const updateEmissionScope3 = async (data: any) => {
  try {
    const result = await axios.patch(
      `${apiRoutes.UPDATE_EMISSION_SCOPE3}`,
      data,
    )
    return result
  } catch (err) {
    throw err
  }
}

export const deleteEmission = async (id: string) => {
  try {
    const result = await axios.delete(
      `${apiRoutes.DELETE_EMISSION_SCOPE3}/${id}`,
    )
    return result
  } catch (err) {
    throw err
  }
}

export const getCheckDeleteEmission = async (id: string) => {
  try {
    const result = await axios.get(
      `${apiRoutes.CHECK_DELETE_EMISSION_SCOPE3}/${id}`,
    )
    return result
  } catch (err) {
    throw err
  }
}

export const updateRegistrationDataUploadImage = async (
  data: any,
  id: string,
) => {
  try {
    const result = await axios.put(
      `${apiRoutes.UPDATE_DATA_UPLOAD_IMAGE}/${id}`,
      data,
    )
    return result
  } catch (err) {
    throw err
  }
}

export const getCheckDeleteBranch = async (id: string) => {
  try {
    const result = await axios.get(
      `${apiRoutes.SETTING_BRANCH}/${id}/registration-data`,
    )
    return result
  } catch (err) {
    throw err
  }
}

export const getCheckDeleteBranchId = async (id: string) => {
  try {
    const result = await axios.get(`${apiRoutes.SETTING_BRANCH}/${id}/check`)
    return result
  } catch (err) {
    throw err
  }
}

export const getListGhg = async (params: any) => {
  try {
    const result = await axios.get(apiRoutes.GHG, { params })
    return result
  } catch (err) {
    throw err
  }
}

export const getDefaultPage = (isRoute: boolean = false) => {
  const pageUrl = 'dashboard/graph'
  return isRoute ? pageUrl : `/${pageUrl}`
}

export const updateTutorialStep = async (data: IPatchTutorialStepAPI) => {
  try {
    await axios.patch(apiRoutes.UPDATE_TUTORIAL_STEP, data)
  } catch (err) {
    throw err
  }
}

export const getFolder = async (id: string, params: any) => {
  try {
    const result = await axios.get(`${apiRoutes.DOCUMENTS}/${id}/folders`, {
      params,
    })
    return result
  } catch (err) {
    throw err
  }
}

export const moveDocument = async (id: string, body: { to: string }) => {
  try {
    const result = await axios.patch(`${apiRoutes.DOCUMENTS}/${id}/move`, body)
    return result
  } catch (err) {
    throw err
  }
}

export const moveDocumentToTrash = async (id: string) => {
  try {
    const result = await axios.patch(`/v1/documents/${id}/trash`)
    return result
  } catch (err) {
    throw err
  }
}
export const createFolder = async (data: IFolderDataBody) => {
  try {
    const result = await axios.post(apiRoutes.getFolderRoute(data.id), data)
    return result
  } catch (err) {
    throw err
  }
}

export const checkUploadDuplicateName = async (
  id: string,
  body: { filenames: string[] },
) => {
  try {
    const result = await axios.put(
      `${apiRoutes.DOCUMENTS}/${id}/check-filename`,
      body,
    )
    return result
  } catch (err) {
    throw err
  }
}

export const uploadFilesFolder = async (id: string, data: any) => {
  try {
    const result = await axios.post(`${apiRoutes.DOCUMENTS}/${id}/files`, data)
    return result
  } catch (err) {
    throw err
  }
}

export const getFileURL = async (id: string, params?: { type: string }) => {
  try {
    const result = await axios.get(`${apiRoutes.DOCUMENTS}/${id}/url`, {
      params,
    })
    return result
  } catch (err) {
    throw err
  }
}

export const renameFolder = async (data: IFolderDataBody) => {
  try {
    const result = await axios.patch(
      apiRoutes.getRenameFolderRoute(data.id),
      data,
    )
    return result
  } catch (err) {
    throw err
  }
}

export const getUnreadNotifications = async () => {
  try {
    const result = await axios.get(apiRoutes.GET_UNREAD_NOTI)
    return result
  } catch (err) {
    throw err
  }
}

export const readNotifications = async () => {
  try {
    return await axios.post(apiRoutes.MARK_AS_READ_NOTI)
  } catch (err) {
    throw err
  }
}

export const readNotification = async (id: string) => {
  try {
    return await axios.post(`${apiRoutes.NOTIFICATION}/${id}/read`)
  } catch (err) {
    throw err
  }
}

export const getNotificationDetail = async (id: string) => {
  try {
    return await axios.get(`${apiRoutes.NOTIFICATION}/detail/${id}`)
  } catch (err) {
    throw err
  }
}

export const getListEmissionScopeById = async (data: any) => {
  try {
    const result = await axios.get(`${apiRoutes.EMISSON}/${data.id}/scope`, {
      params: data.params,
    })
    return result
  } catch (err) {
    throw err
  }
}

export const settingPassword = async (params: any) => {
  try {
    const result = await axios.post(apiRoutes.SETTING_PASSWORD, { ...params })
    return result
  } catch (err) {
    throw err
  }
}

export const getSystemSettingScope = async () => {
  try {
    const result = await axios.get(`${apiRoutes.SYSTEM_SETTING}/scope`)
    return result
  } catch (err) {
    throw err
  }
}

export const getCurrentCompanyInformation = async () => {
  try {
    const result = await axios.get(`${apiRoutes.COMPANIES}/current-company`)
    return result
  } catch (err) {
    throw err
  }
}

export const updateCurrentCompanyInfomation = async (
  params: ICompanyFormData,
) => {
  try {
    const result = await axios.patch(`${apiRoutes.COMPANIES}/current-company`, {
      ...params,
    })
    return result
  } catch (err) {
    throw err
  }
}
export const getListCompany = async (params: any) => {
  try {
    const result = await axios.get(
      `${apiRoutes.COMPANIES}/approved-and-current`,
      { params },
    )
    return result
  } catch (err) {
    throw err
  }
}

export const getListCompanyInvited = async (params: any) => {
  try {
    const result = await axios.get(apiRoutes.COMPANIES, { params })
    return result
  } catch (err) {
    throw err
  }
}

export const approvalCompany = async (id: string) => {
  try {
    const result = await axios.patch(`${apiRoutes.COMPANIES}/${id}/approve`)
    return result
  } catch (err) {
    throw err
  }
}

export const getListCompanyShared = async (params: any) => {
  try {
    const result = await axios.get(apiRoutes.COMPANIES_SHARED, { params })
    return result
  } catch (err) {
    throw err
  }
}

export const getCompaniesNoneGroup = async (params: any) => {
  try {
    const result = await axios.get(
      `${apiRoutes.COMPANIES}/${params.groupId}/none-group`,
      {
        params,
      },
    )
    return result
  } catch (err) {
    throw err
  }
}

export const getCompanyByCode = async (code: string) => {
  try {
    const result = await axios.get(`${apiRoutes.COMPANIES}/${code}/code`)
    return result
  } catch (err) {
    throw err
  }
}

export const getGroups = async () => {
  try {
    const result = await axios.get(apiRoutes.GROUP)
    return result
  } catch (err) {
    throw err
  }
}

export const inviteCompany = async (code: string) => {
  try {
    const result = await axios.patch(`${apiRoutes.COMPANIES}/${code}/invite`)
    return result
  } catch (err) {
    throw err
  }
}

export const createGroup = async (params: ICreateGroupParams) => {
  try {
    const result = await axios.post(apiRoutes.GROUP, params)
    return result
  } catch (err) {
    throw err
  }
}

export const editGroup = async (params: ICreateGroupParams) => {
  try {
    const result = await axios.patch(
      `${apiRoutes.GROUP}/${params.groupId}/rename`,
      {
        name: params.name,
      },
    )
    return result
  } catch (err) {
    throw err
  }
}

export const moveGroup = async (id: string, params: IMoveGroupParams) => {
  try {
    const result = await axios.put(
      `${apiRoutes.GROUP}/${id}/move-group`,
      params,
    )
    return result
  } catch (err) {
    throw err
  }
}

export const sharedCompany = async (id: string, data: any) => {
  try {
    const result = await axios.patch(
      `${apiRoutes.COMPANIES}/${id}/shared`,
      data,
    )
    return result
  } catch (err) {
    throw err
  }
}

export const removeGroup = async (id: string) => {
  try {
    const result = await axios.delete(`${apiRoutes.GROUP}/${id}`)
    return result
  } catch (err) {
    throw err
  }
}

export const getCompaniesFromSelectedGroup = async (
  id: string,
  params: any,
) => {
  try {
    const result = await axios.get(`${apiRoutes.GROUP}/${id}/companies`, params)
    return result
  } catch (err) {
    throw err
  }
}

export const addCompanyToGroup = async (
  id: string,
  params: IMoveGroupParams,
) => {
  try {
    const result = await axios.post(
      `${apiRoutes.GROUP}/${id}/companies`,
      params,
    )
    return result
  } catch (err) {
    throw err
  }
}

export const getCompanyDetail = async (id: string) => {
  try {
    const result = await axios.get(`${apiRoutes.COMPANIES}/${id}/collaboration`)
    return result
  } catch (err) {
    throw err
  }
}

export const removeCompanyFromGroup = async (
  params: IRemoveCompanyFromGroupParams,
) => {
  try {
    const result = await axios.delete(
      `${apiRoutes.GROUP_COMPANY}/${params.groupId}/${params.companyId}`,
    )
    return result
  } catch (err) {
    throw err
  }
}

export const getListGroupOfCompany = async (params: any) => {
  try {
    const result = await axios.get(`${apiRoutes.GROUP}/current-company`, {
      params,
    })
    return result
  } catch (err) {
    throw err
  }
}

export const getClassificationByScopeId = async (id: string, params: any) => {
  try {
    const result = await axios.get(`${apiRoutes.SCOPE}/${id}/classifications`, {
      params,
    })
    return result
  } catch (error) {
    throw error
  }
}

export const getItemsByClassificationId = async (id: string, params: any) => {
  try {
    const result = await axios.get(`${apiRoutes.CLASSIFICATIONS}/${id}/items`, {
      params,
    })
    return result
  } catch (error) {
    throw error
  }
}

export const getEmissionByItemId = async (id: string, params: any) => {
  try {
    const result = await axios.get(`${apiRoutes.ITEM}/${id}/emissions`, {
      params,
    })
    return result
  } catch (error) {
    throw error
  }
}

export const getItemsByBranchId = async (id: string) => {
  try {
    const result = await axios.get(`${apiRoutes.SETTING_BRANCH}/${id}/items`)
    return result
  } catch (error) {
    throw error
  }
}

export const getSearchConditions = async (params: any) => {
  try {
    const result = await axios.get(apiRoutes.SEARCH_CONDITION, { params })
    return result
  } catch (error) {
    throw error
  }
}

export const saveSearchCondition = async (params: any) => {
  try {
    const result = await axios.post(apiRoutes.SEARCH_CONDITION, params)
    return result
  } catch (error) {
    throw error
  }
}

export const deleteSelectedConditions = async (params: any) => {
  try {
    const result = await axios.delete(apiRoutes.SEARCH_CONDITION, {
      data: params,
    })
    return result
  } catch (error) {
    throw error
  }
}

export const updateSearchCondition = async (id: string, params: any) => {
  try {
    const result = await axios.patch(
      `${apiRoutes.SEARCH_CONDITION}/${id}`,
      params,
    )
    return result
  } catch (error) {
    throw error
  }
}

export const updateSearchConditionName = async (
  id: string,
  params: { name: string },
) => {
  try {
    const result = await axios.patch(
      `${apiRoutes.SEARCH_CONDITION}/${id}/name`,
      params,
    )
    return result
  } catch (error) {
    throw error
  }
}

export const getAnalysisFilterSettings = async (params: any) => {
  try {
    const result = await axios.get(apiRoutes.ANALYSIS_FILTER_SETTING, {
      params,
    })
    return result
  } catch (error) {
    throw error
  }
}

export const getAnalysisFilterSetting = async (id: string) => {
  try {
    const result = await axios.get(`${apiRoutes.ANALYSIS_FILTER_SETTING}/${id}`)
    return result
  } catch (error) {
    throw error
  }
}

export const saveAnalysisFilterSetting = async (params: any) => {
  try {
    const result = await axios.post(apiRoutes.ANALYSIS_FILTER_SETTING, params)
    return result
  } catch (error) {
    throw error
  }
}

export const updateAnalysisFilterSetting = async (id: string, params: any) => {
  try {
    const result = await axios.put(
      `${apiRoutes.ANALYSIS_FILTER_SETTING}/${id}`,
      params,
    )
    return result
  } catch (error) {
    throw error
  }
}

export const getListShareDatas = async (params: IPaginationParams) => {
  try {
    const result = await axios.get(`${apiRoutes.SHARE_DATA}/requested`, {
      params,
    })
    return result
  } catch (error) {
    throw error
  }
}

export const requestShareDatas = async (params: IRequestShareData) => {
  try {
    const result = await axios.post(apiRoutes.SHARE_DATA, params)
    return result
  } catch (error) {
    throw error
  }
}

export const getListRequestShareDatas = async (
  params: IListRequestShareDataParams,
) => {
  try {
    const result = await axios.get(apiRoutes.SHARE_DATA, { params })
    return result
  } catch (error) {
    throw error
  }
}

export const shareTotal = async (id: string, params: IShareEmissionParams) => {
  try {
    const result = await axios.patch(
      `${apiRoutes.SHARE_DATA}/${id}/share`,
      params,
    )
    return result
  } catch (error) {
    throw error
  }
}

export const updateTotal = async (id: string, params: IShareEmissionParams) => {
  try {
    const result = await axios.patch(
      `${apiRoutes.SHARE_DATA}/${id}/total`,
      params,
    )
    return result
  } catch (error) {
    throw error
  }
}

export const getListCompanyApproved = async (params: IPaginationParams) => {
  try {
    const result = await axios.get(`${apiRoutes.COMPANIES}/approved`, {
      params,
    })
    return result
  } catch (err) {
    throw err
  }
}

export const contactUsForPremium = async (data: IContactDataAPI) => {
  try {
    const result = await axios.post(
      `${apiRoutes.CONTACT_US}/request-premium`,
      data,
    )
    return result
  } catch (err) {
    throw err
  }
}

export const getBranchesFromCompany = async (params: any) => {
  try {
    const result = await axios.get(
      `${apiRoutes.GROUP_COMPANY}/${params.groupId}/${params.companyId}/branches`,
    )
    return result
  } catch (err) {
    throw err
  }
}

export const updateGroupCompanyBranches = async (params: any) => {
  try {
    const result = await axios.post(
      `${apiRoutes.GROUP_COMPANY}/${params.groupId}/branches`,
      params.changeItems,
    )
    return result
  } catch (err) {
    throw err
  }
}

export const editEmissionScope = async (id: string, data: any) => {
  try {
    const result = await axios.patch(`${apiRoutes.EMISSON}/${id}`, data)
    return result
  } catch (err) {
    throw err
  }
}

export const getGoalVersionList = async (params: any) => {
  try {
    const result = await axios.get(apiRoutes.GOAL, { params })
    return result
  } catch (err) {
    throw err
  }
}

export const getListCutOffPlans = async (id: string, params: ICutoffParams) => {
  try {
    const result = await axios.get(`${apiRoutes.GOAL}/${id}/cut-off`, {
      params,
    })
    return result
  } catch (error) {
    throw error
  }
}

export const settingStatusCutoffPlan = async (
  id: string,
  params: ICutoffParams,
) => {
  try {
    const result = axios.patch(
      `${apiRoutes.CUT_OFF}/${id}/setting-status`,
      params,
    )
    return result
  } catch (error) {
    throw error
  }
}

export const deleteCutoffPlan = async (id: string) => {
  try {
    const result = axios.delete(`${apiRoutes.CUT_OFF}/${id}`)
    return result
  } catch (error) {
    throw error
  }
}

export const getCustomCutoff = async (id: string) => {
  try {
    const result = axios.get(`${apiRoutes.GOAL}/${id}/cut-off-custom`)
    return result
  } catch (error) {
    throw error
  }
}

export const updateCustomCutoff = async (
  id: string,
  params: ICustomTotalParam,
) => {
  try {
    const result = axios.patch(`${apiRoutes.GOAL}/${id}/total-customs`, params)
    return result
  } catch (error) {
    throw error
  }
}

export const getTotalEmissionAmountOfBaseYear = async (
  year: number,
  branchId?: string,
) => {
  try {
    const result = await axios.get(
      `${apiRoutes.GOAL}/${year}/total-emission-amount`,
      { params: { branchId } },
    )
    return result
  } catch (error) {
    throw error
  }
}

export const createGoalVersion = async (data: IParamCreateGoalVersion) => {
  try {
    const result = await axios.post(apiRoutes.GOAL, data)
    return result
  } catch (err) {
    throw err
  }
}

export const getVersionSelect = async () => {
  try {
    const result = axios.get(`${apiRoutes.GOAL}/select`)
    return result
  } catch (error) {
    throw error
  }
}

export const getEmissionCutStrategies = async () => {
  try {
    const result = axios.get(apiRoutes.EMISSION_CUT_STRATEGIES)
    return result
  } catch (error) {
    throw error
  }
}

export const duplicateGoalVersion = async (id: string) => {
  try {
    const result = axios.put(`${apiRoutes.GOAL}/${id}/duplicate`)
    return result
  } catch (error) {
    throw error
  }
}

export const deleteGoalVersion = async (id: string) => {
  try {
    const result = axios.delete(`${apiRoutes.GOAL}/${id}`)
    return result
  } catch (error) {
    throw error
  }
}

export const getDetailGoalVersion = async (id: string) => {
  try {
    const result = axios.get(`${apiRoutes.GOAL}/${id}`)
    return result
  } catch (error) {
    throw error
  }
}

export const updateGoalVersion = async (
  id: string,
  data: Partial<IDetailGoalVersion>,
) => {
  try {
    const result = axios.put(`${apiRoutes.GOAL}/${id}`, data)
    return result
  } catch (error) {
    throw error
  }
}

export const addCutoffPlan = async (id: string, params: IGoalCutoffParams) => {
  try {
    const result = axios.post(`${apiRoutes.GOAL}/${id}/cut-off`, params)
    return result
  } catch (error) {
    throw error
  }
}

export const getReductionSelect = async () => {
  try {
    const result = axios.get(`${apiRoutes.CUT_OFF}/system`)
    return result
  } catch (error) {
    throw error
  }
}

export const getDetailCutOff = async (id: string) => {
  try {
    const result = axios.get(`${apiRoutes.CUT_OFF}/${id}`)
    return result
  } catch (error) {
    throw error
  }
}

export const getReductionSimulation = async (
  params: IGoalVersionSimulationParams,
) => {
  try {
    const result = axios.get(`${apiRoutes.GOAL}/simulation`, { params })
    return result
  } catch (error) {
    throw error
  }
}

export const updateAccountInfo = async (params: IUpdateUserSettingData) => {
  try {
    const result = axios.patch(`${apiRoutes.ACCOUNT_INFO}/update-name`, params)
    return result
  } catch (error) {
    throw error
  }
}

export const updateAccountInfoEmail = async (params: IUpdateEmailData) => {
  try {
    const result = axios.patch(`${apiRoutes.ACCOUNT_INFO}/change-email`, params)
    return result
  } catch (error) {
    throw error
  }
}

export const verifyChangeEmail = async (params: IVerifyEmail) => {
  try {
    const result = axios.get(apiRoutes.VERIFY_EMAIL, {
      params,
    })
    return result
  } catch (error) {
    throw error
  }
}

export const getClassificationElectricId = async () => {
  try {
    const result = axios.get(`${apiRoutes.CLASSIFICATIONS}/electric`)
    return result
  } catch (error) {
    throw error
  }
}

export const createRegistrations = async (params: any) => {
  try {
    const result = await axios.post(`${apiRoutes.REGISTRATION}/bulk`, params)
    return result
  } catch (err) {
    throw err
  }
}

export const checkRemoveBranch = async (branchId: string) => {
  try {
    const result = axios.get(`${apiRoutes.SETTING_BRANCH}/${branchId}/delete`)
    return result
  } catch (error) {
    throw error
  }
}

export const removeBranch = async (branchId: string) => {
  try {
    const result = axios.delete(`${apiRoutes.SETTING_BRANCH}/${branchId}`)
    return result
  } catch (error) {
    throw error
  }
}

export const validateRow = async (params: any) => {
  try {
    const result = await axios.post(
      `${apiRoutes.REGISTRATION}/validate`,
      params,
    )
    return result
  } catch (error) {
    throw error
  }
}

export const getUploadHistory = async (params: any) => {
  try {
    const result = await axios.get(apiRoutes.UPLOAD_HISTORIES, { params })
    return result
  } catch (err) {
    throw err
  }
}

export const downloadHistoryCsv = async (params: {
  uploadHistoryId: string
}) => {
  try {
    const result = await axios.get(
      `${apiRoutes.REGISTRATION}/history-download`,
      {
        params,
        responseType: 'blob',
      },
    )
    return result
  } catch (err) {
    throw err
  }
}
